import { useEffect } from 'react';

import type { Locale } from '@bitwize/i18n-messages';

import { rememberLocale } from './preference';

/**
 * Record the locale currently being viewed.
 *
 * Mounted once at the root, so it covers every route rather than only the
 * language switcher. That matters because the switcher is a plain link — it has
 * to work before hydration and with JavaScript off — so there is no click
 * handler to hang this on. The page that link lands on does the remembering.
 *
 * The URL always wins over the stored value. Someone who follows an Arabic link
 * is reading Arabic right now, whatever they last chose, and their preference
 * should follow them rather than argue with them. Nothing here redirects: a
 * stored preference decides where a bare `/` goes, and never overrides an
 * explicit URL.
 *
 * The effect is client-only, which is correct — there is nothing to persist
 * during server rendering, and the write is invisible to the DOM, so it causes
 * no hydration mismatch.
 */
export function useRememberLocale(locale: Locale): void {
  useEffect(() => {
    rememberLocale(locale);
  }, [locale]);
}
